import { render, staticRenderFns } from "./MarketViewLiveDetailV5.vue?vue&type=template&id=fbb2397e"
import script from "./MarketViewLiveDetailV5.vue?vue&type=script&lang=js"
export * from "./MarketViewLiveDetailV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports